import { connect } from 'react-redux';
import { selectors } from '../../../root/reading/root';
import fetchFormData from '../../../api/forms/reading/formsActions';
import ProbeDetailsBody from '../../../features/probeDetails/reading/ProbeDetailsBody';

const mapStateToProps = (state, ownProps) => ({
    content: selectors.getFormByID(state, ownProps.result.formUid),
    isFormFetching: selectors.isFormFetching(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchFormData: () => dispatch(fetchFormData(ownProps.result.measure, ownProps.result.formUid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProbeDetailsBody);
